<div class="container-fluid" >
    <div class="row">
        <div class="col-9 m-auto">
            <div class="card p-4">
                <div class="card-body">
                    <form novalidate="">
                        <div class="custom-form ">
                            <div class="row">
                                <div *ngIf="decsionObject" class="col-lg-12" style="margin: auto;">

                                    <div>
                                        <div class="row" >
                                            <div class="row col-12" >
                                                <h4 class="text-center">
                                                    {{ "DecsionTypeName" | translate }} -
                                                    <span style="font-weight: bold">{{ decsionObject.decsionNumber }} / {{ decsionObject.hijriYear }}</span>
                                                </h4>
                                                <div class="col-12">
                                                    <h6 *ngIf="decsionObject.decsionTypeId == 1" style="font-weight: bold">
                                                        عدم ثبوت المخالفة
                                                    </h6>
                                                    <h6 *ngIf="decsionObject.decsionTypeId == 2" style="font-weight: bold">
                                                        ثبوت المخالفة
                                                    </h6>
                                                    <div  style="position: relative;">
                                                        <p>
                                                            {{decsionObject.decsion}}
                                                        </p>
                                                        <!--<div *ngIf="decsionObject.isObjectionAccepted" class="canceled">{{'Canceled' | translate}}</div>-->
                                                    </div>
                                                </div>
                                                <div class="col-12" style="text-align: center; margin-right: auto;">
                                                    <button (click)="PrintDecision()" class="btn btn-secondary m-2">
                                                        <i class="fa fa-print"></i> {{ "PrintDecision" | translate }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>